import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { GroupedComponentsValidator } from 'sos-common/js/components/FormControls/GroupedComponentsValidator';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { Register } from 'sos-common/js/commonTypes/Registers.types';
import {
  ResearchOrderStore,
  ResearchOrderRegisters,
  researchOrderFiles,
  ResearchOrderClientErrors,
} from '../../../models/ResearchOrderStore.types';
import {
  setFormValue,
  addFilesAction,
  addFileActionFunc,
  removeFilesAction,
  removeFileActionFunc,
  clearErrorDispatcher,
  clearError,
} from 'sos-eservice-common/js/Redux/Actions';
import { ResearchOrderModel, RegisterPeriodClarification } from '../../../models';
import ClarificationList from '../../../components/researchOrder/clarificationList';
import { RegBoundClarification } from '../../../components/researchOrder/Clarification.types';
import { RegisterPeriodClarificationItemStrings } from '../../../components/researchOrder/Clarification.types';
import {
  fileInputAcceptedTypesVariabellista,
  getErrorMessageByFieldName,
  mandatoryIfNotOnlyDeceased,
} from '../../../utilities/helpers';
import { setClarificationRegistersValue } from '../actions/clarification.registers.actions';
import { HTMLAttributes } from 'react';

export interface Step2Props extends StepChildProps {
  Translate?: translateFunc;
  registers?: ResearchOrderRegisters;
  setFormValue?: typeof setFormValue;
  setClarificationRegistersValue?: typeof setClarificationRegistersValue;
  researchOrder: ResearchOrderModel;
  researchOrderId: string;
  deleteFile: removeFileActionFunc;
  postFile: addFileActionFunc;
  files: researchOrderFiles;
  clearError: clearError;
  clarificationItemStrings: RegisterPeriodClarificationItemStrings;
  validationResults: ValidationResult[];
  errors: ResearchOrderClientErrors;
  touchedMap: Map<any, any>;
}

export interface groupedRegBoundClarification {
  internalRegistrieshealthData: RegBoundClarification[];
  internalRegistriescauseOfDeath: RegBoundClarification[];
  internalRegistriessocialServices: RegBoundClarification[];
}

export interface Step2State {
  isValid?: boolean;
  // registerBoundClarification: groupedRegBoundClarification;
  // internalRegistrieshealthData: RegisterPeriodClarification[];
  // internalRegistriescauseOfDeath: RegisterPeriodClarification[];
  // internalRegistriessocialServices: RegisterPeriodClarification[];
  stepId: number;
  clarificationIsTouched?: boolean;
}

function makeRegBoundClarification(
  count: number,
  clarifications: RegisterPeriodClarification[],
  internalregistries: number[],
  touchedMap: Map<any, any>,
) {
  return function (r: Register, i: number) {
    const index = count + i;
    return {
      DhsId: r.DhsId,
      Name: r.Name,
      clarification: clarifications.filter((c) => c && c.Register === r.Name)[0],
      index,
      isSelected: internalregistries.some((registry) => registry === r.DhsId),
      touchedMap,
    } as RegBoundClarification;
  };
}

function joinRegistersAndClarifications(
  registers: ResearchOrderRegisters,
  clarifications: RegisterPeriodClarification[],
  internalregistries: number[],
  touchedMap: Map<any, any>,
): groupedRegBoundClarification {
  clarifications = clarifications || [];
  let count = 0;
  const result = {} as groupedRegBoundClarification;
  if (!internalregistries) {
    internalregistries = [];
  }

  result.internalRegistrieshealthData = registers.internalRegistrieshealthData.map(
    makeRegBoundClarification(count, clarifications, internalregistries, touchedMap),
  );

  count += registers.internalRegistrieshealthData.length;

  result.internalRegistriescauseOfDeath = registers.internalRegistriescauseOfDeath.map(
    makeRegBoundClarification(count, clarifications, internalregistries, touchedMap),
  );

  count += registers.internalRegistriescauseOfDeath.length;

  result.internalRegistriessocialServices = registers.internalRegistriessocialServices.map(
    makeRegBoundClarification(count, clarifications, internalregistries, touchedMap),
  );

  return result;
}

class Step2 extends React.Component<Step2Props, Step2State> {
  constructor(props: Step2Props) {
    super(props);
    this.state = {
      isValid: this.props.stepState.isDone,
      stepId: this.props.stepState.stepId,
      clarificationIsTouched: false,
    };
  }
  getTitle = () => 'Register';

  getGroupedFromProps = () => {
    const { registers, researchOrder, touchedMap } = this.props;
    const { RegisterPeriodClarifications, InternalRegisters } = researchOrder;
    const registerBoundClarification = joinRegistersAndClarifications(
      registers,
      RegisterPeriodClarifications,
      InternalRegisters,
      touchedMap,
    );
    return registerBoundClarification;
  };

  onHealthDataChange = (clarifications: RegBoundClarification[]) => {
    const registerBoundClarification = this.getGroupedFromProps();
    registerBoundClarification.internalRegistrieshealthData = clarifications;
    this.onChangeClarifications(registerBoundClarification);
  };

  onCauseOfDeathChange = (clarifications: RegBoundClarification[]) => {
    const registerBoundClarification = this.getGroupedFromProps();
    registerBoundClarification.internalRegistriescauseOfDeath = clarifications;
    this.onChangeClarifications(registerBoundClarification);
  };

  onSocialServicesChange = (clarifications: RegBoundClarification[]) => {
    const registerBoundClarification = this.getGroupedFromProps();
    registerBoundClarification.internalRegistriessocialServices = clarifications;
    this.onChangeClarifications(registerBoundClarification);
  };

  onChangeClarifications = (registerBoundClarification: groupedRegBoundClarification) => {
    // TODO: getregistryName in there!! or index!
    const clarifications = [];
    const internalRegistries = [];
    const toucedMap = new Map<any, any>();

    for (const key in registerBoundClarification) {
      if (registerBoundClarification.hasOwnProperty(key)) {
        const element = registerBoundClarification[key] as RegBoundClarification[];
        element.forEach((e) => {
          if (e.clarification) {
            clarifications.push(e.clarification);
          }
          if (e.isSelected) {
            internalRegistries.push(e.DhsId);
          }
          if (e.touchedMap) {
            e.touchedMap.forEach((value: boolean, key: string) => {
              if (!toucedMap.has(key)) {
                toucedMap.set(key, value);
              }
            });
          }
        });
      }
    }

    this.props.setClarificationRegistersValue(
      {
        fieldName: 'CurrentResearchOrder.InternalRegisters',
        isTouched: this.state.clarificationIsTouched,
        value: internalRegistries,
      },
      {
        fieldName: 'CurrentResearchOrder.RegisterPeriodClarifications',
        isTouched: this.state.clarificationIsTouched,
        value: clarifications,
      },
      toucedMap,
    );
  };

  addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  };
  removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const researchOrderId = this.props.researchOrderId;
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };
  setClarificationIsTouched = () => {
    if (!this.state.clarificationIsTouched) {
      this.setState({
        clarificationIsTouched: true,
      });
    }
  };
  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  private getGroupedErrorMessageObject = (fieldName: string) => {
    const { validationResults } = this.props;
    const errorMessage = getErrorMessageByFieldName(validationResults, fieldName);
    const id = fieldName + '-errormessage';
    let ariaAttributes = {} as HTMLAttributes<any>;
    if (errorMessage) {
      ariaAttributes['aria-invalid'] = true;
      ariaAttributes['aria-describedby'] = id;
    } else {
      ariaAttributes = null;
    }
    return { errorMessage, id, ariaAttributes };
  };

  render() {
    const { Translate, researchOrder, clarificationItemStrings, files, validationResults, errors } = this.props;
    const registerBoundClarification = this.getGroupedFromProps();
    const InternalRegistersErrorMessageObject = this.getGroupedErrorMessageObject(
      'CurrentResearchOrder.InternalRegisters',
    );

    return (
      <div id="step2" tabIndex={-1}>
        <h2>{Translate('/orderformpage/VilkaRegisterBest')}</h2>
        <h3 className="inlineblock infobubble-absolute">
          {Translate('/orderformpage/selectregisters')}
          <Tooltip text={Translate('/orderformpage/selectregistersinfo')} />
        </h3>

        <br />
        <GroupedComponentsValidator
          errorId={InternalRegistersErrorMessageObject.id}
          errorOnTop={true}
          errorMessage={InternalRegistersErrorMessageObject.errorMessage}>
          <ClarificationList
            id="halsodataregister"
            strings={{
              ...clarificationItemStrings,
              title: Translate('/orderformpage/Halsodataregister'),
            }}
            touchedCallback={this.setClarificationIsTouched}
            regBoundClarifications={registerBoundClarification.internalRegistrieshealthData}
            validationResults={validationResults}
            onChange={this.onHealthDataChange}
            errorAriaAttributes={InternalRegistersErrorMessageObject.ariaAttributes}
          />
          <br />
          <ClarificationList
            id="dodsorsaksregistret"
            strings={{
              ...clarificationItemStrings,
              title: Translate('/orderformpage/Dodsorsaksregistret'),
            }}
            touchedCallback={this.setClarificationIsTouched}
            regBoundClarifications={registerBoundClarification.internalRegistriescauseOfDeath}
            validationResults={validationResults}
            onChange={this.onCauseOfDeathChange}
            errorAriaAttributes={InternalRegistersErrorMessageObject.ariaAttributes}
          />
          <br />
          <ClarificationList
            id="socialtjanstregister"
            strings={{
              ...clarificationItemStrings,
              title: Translate('/orderformpage/Socialtjanstregister'),
            }}
            touchedCallback={this.setClarificationIsTouched}
            regBoundClarifications={registerBoundClarification.internalRegistriessocialServices}
            validationResults={validationResults}
            onChange={this.onSocialServicesChange}
            errorAriaAttributes={InternalRegistersErrorMessageObject.ariaAttributes}
          />
        </GroupedComponentsValidator>

        <hr className="formdivider" />
        <div role="group" aria-labelledby="bifogaVariabellistaLabel">
          <h2 id="bifogaVariabellistaLabel" className="inlineblock">
            {Translate('/orderformpage/bifogaVariabellista')}
          </h2>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfobubblorForskarBestallning/BifogaVariabellista')} />
          </div>

          <Fileupload
            disabled={!this.props.researchOrderId}
            heading={Translate('/orderformpage/Variabellista')}
            upload={Translate('/orderformpage/uploadFile')}
            nofilesText={Translate('/orderformpage/noFilesUploaded')}
            fieldName="variabellista"
            value={files.variabellista}
            onAdd={this.addFiles}
            onRemove={this.removeFile}
            mimetype={fileInputAcceptedTypesVariabellista}
            max={2}
            mandatory={true}
            id={'variabellista'}
            clientError={errors['variabellista']}
            errorMessage={getErrorMessageByFieldName(validationResults, 'CurrentResearchOrder.variabellista')}
            allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint och textdokument. Max 10 MB.'}
          />
        </div>
        <hr className="formdivider" />
        <div role="group" aria-labelledby="bifogaKodlistaPatientRegistretLabel">
          <h2 id="bifogaKodlistaPatientRegistretLabel" className="inlineblock">
            {'Bifoga kodväljare för Patientregistret'}
          </h2>
          <div className="inlineblock">
            <Tooltip
              text={
                'Bifoga en lista med koder som du beställer från Patientregistret. Du hittar mallen för detta på vår webbplats.'
              }
            />
          </div>

          <Fileupload
            disabled={!this.props.researchOrderId}
            heading={'Kodlista'}
            upload={Translate('/orderformpage/uploadFile')}
            nofilesText={Translate('/orderformpage/noFilesUploaded')}
            fieldName="kodlistaPatientRegistret"
            value={files.kodlistaPatientRegistret}
            onAdd={this.addFiles}
            onRemove={this.removeFile}
            mimetype={fileInputAcceptedTypesVariabellista}
            max={5}
            id={'kodlistaPatientRegistret'}
            clientError={errors['kodlistaPatientRegistret']}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.kodlistaPatientRegistret',
            )}
            allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint och textdokument. Max 10 MB.'}
          />
        </div>
        <hr className="formdivider" />
        <div role="group" aria-labelledby="bifogaKodlistaLakemedelsRegistretLabel">
          <h2 id="bifogaKodlistaLakemedelsRegistretLabel" className="inlineblock">
            {'Bifoga kodväljare för Läkemedelsregistret'}
          </h2>
          <div className="inlineblock">
            <Tooltip
              text={
                'Bifoga en lista med koder om du beställer uppgifter från Läkemedelsregistret. Du hittar mallen för detta på vår webbplats.'
              }
            />
          </div>

          <Fileupload
            disabled={!this.props.researchOrderId}
            heading={'Kodlista'}
            upload={Translate('/orderformpage/uploadFile')}
            nofilesText={Translate('/orderformpage/noFilesUploaded')}
            fieldName="kodlistaLakemedelsRegistret"
            value={files.kodlistaLakemedelsRegistret}
            onAdd={this.addFiles}
            onRemove={this.removeFile}
            mimetype={fileInputAcceptedTypesVariabellista}
            max={5}
            id={'kodlistaLakemedelsRegistret'}
            clientError={errors['kodlistaLakemedelsRegistret']}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.kodlistaLakemedelsRegistret',
            )}
            allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint och textdokument. Max 10 MB.'}
          />
        </div>
        <hr className="formdivider" />
        <div role="group" aria-labelledby="bifogaKodlistaDodsorsaksRegistretLabel">
          <h2 id="bifogaKodlistaDodsorsaksRegistretLabel" className="inlineblock">
            {'Bifoga kodväljare för Dödsorsaksregistret'}
          </h2>
          <div className="inlineblock">
            <Tooltip
              text={
                'Bifoga en lista med koder om du beställer uppgifter från Dödsorsaksregistret. Du hittar mallen för detta på vår webbplats.'
              }
            />
          </div>

          <Fileupload
            disabled={!this.props.researchOrderId}
            heading={'Kodlista'}
            upload={Translate('/orderformpage/uploadFile')}
            nofilesText={Translate('/orderformpage/noFilesUploaded')}
            fieldName="kodlistaDodsorsaksRegistret"
            value={files.kodlistaDodsorsaksRegistret}
            onAdd={this.addFiles}
            onRemove={this.removeFile}
            mimetype={fileInputAcceptedTypesVariabellista}
            max={5}
            id={'kodlistaDodsorsaksRegistret'}
            clientError={errors['kodlistaDodsorsaksRegistret']}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'CurrentResearchOrder.kodlistaDodsorsaksRegistret',
            )}
            allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint och textdokument. Max 10 MB.'}
          />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: ResearchOrderStore) => {
  const translator = makeTranslator(state.globals.translations);
  const clarificationItemStrings = {
    StartDate: {
      label: translator('/orderformpage/InternalRegistersFromYearWithStar'),
      placeholder: translator('/orderformpage/InternalRegistersFromYear'),
    },
    EndDate: {
      label: translator('/orderformpage/InternalRegistersTillYearWithStar'),
      placeholder: translator('/orderformpage/InternalRegistersTillYear'),
    },
    FileId: {
      label: mandatoryIfNotOnlyDeceased(state.formModel)
        ? translator('/orderformpage/ChooseFileWithStar')
        : translator('/orderformpage/ChooseFile'),
    },
    Page: {
      label: mandatoryIfNotOnlyDeceased(state.formModel)
        ? translator('/orderformpage/SidaAvsnitt')
        : translator('/orderformpage/SidaAvsnittNoStar'),
      placeholder: translator('/orderformpage/SidaAvsnittNoStar'),
    },
  };
  return {
    Translate: translator,
    registers: state.registers,
    researchOrder: state.formModel,
    researchOrderId: state.globals.orderId,
    files: state.files,
    clarificationItemStrings,
    validationResults: state.validationState.validationResults,
    errors: state.errors,
    touchedMap: state.globals.touchedMap,
  } as Step2Props;
};

const mapDispatch2Props = (dispatch) => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch),
    setClarificationRegistersValue: bindActionCreators(setClarificationRegistersValue, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    clearError: clearErrorDispatcher(dispatch),
  };
};

const StepTwo = connect(mapState2Props, mapDispatch2Props)(Step2);
export { StepTwo };
